import React from 'react';
import {
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  UserAvatar,
  TooltipComponent,
  DataTableBody
} from '../../../../components/Component';
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Button, Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { newRoles, getPublicDocumentUrl } from '../../../../utils/envConfig';
import LoadingComponent from '../../loader/tableLoader';
import DndFlagComponent from '../../dnd/dndFlag';
import NewLeadFlagComponent from '../../new-lead-flag/newLeadFlag';
import SendToPhone from '../../../../components/SendToPhone';
import { findUpper } from '../../../../utils/Utils';
import ProspectStar from '../../../../components/icon/PorspectStar';

const LeadsDataTable = ({
  leads,
  isLoading,
  selectedItemIds, // Note: parent uses selectedItems (array of objects), this might need adjustment if only IDs are needed
  currentSortBy,
  currentSortDir,
  authuser,
  checkedAll,
  isCompactView, // maps to tablesm in parent
  onSelectRow,
  onSelectAllRows,
  onSortColumn,
  onViewDetails,
  onEditLead,
  onReturnLead
  // onSendToPhone is handled by SendToPhone component directly
}) => {
  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <>
      <DataTableBody compact={isCompactView}>
        <DataTableHead className="nk-tb-item">
          <DataTableRow className="nk-tb-col-check">
            <div className="custom-control custom-control-sm custom-checkbox notext">
              <input
                type="checkbox"
                className="custom-control-input"
                id="pid-all-leads" // Changed ID to be unique
                checked={checkedAll}
                onChange={(e) => onSelectAllRows(e)}
                disabled={leads.length === 0}
              />
              <label className="custom-control-label" htmlFor="pid-all-leads"></label>
            </div>
          </DataTableRow>
          <DataTableRow className="d-sm-none d-xxl-table-cell">
            <div
              onClick={() => onSortColumn('lead_source')}
              style={{ cursor: 'pointer' }}
              className="d-sm-none d-xxl-table-cell"
            >
              <span className="d-sm-none d-xxl-table-cell">Lead Source </span>
              {currentSortBy === 'lead_source' && (
                <Icon name={currentSortDir === 'asc' ? 'arrow-long-up' : 'arrow-long-down'} />
              )}
            </div>
          </DataTableRow>
          <DataTableRow>
            <div onClick={() => onSortColumn('first_name')} style={{ cursor: 'pointer' }}>
              <span className="sub-text">
                Name
                {currentSortBy === 'first_name' ? (
                  <Icon className="ms-1" name={currentSortDir === 'asc' ? 'arrow-long-up' : 'arrow-long-down'} />
                ) : (
                  <Icon className="ms-1">
                    <span>&darr;</span>
                    <span>&uarr;</span>
                  </Icon>
                )}
              </span>{' '}
            </div>
          </DataTableRow>
          {authuser?.role &&
            [newRoles.Admin, newRoles.MasterAdmin, newRoles.ChannelPartnerManager].includes(authuser?.role) && (
              <DataTableRow size="md">
                <span className="sub-text">Assigned Agent</span>
              </DataTableRow>
            )}
          <DataTableRow size="md" className="text-start">
            <div onClick={() => onSortColumn('phone')} style={{ cursor: 'pointer' }}>
              <span className="sub-text">
                Phone{' '}
                {currentSortBy === 'phone' ? (
                  <Icon className="ms-1" name={currentSortDir === 'asc' ? 'arrow-long-up' : 'arrow-long-down'} />
                ) : (
                  <Icon className="ms-1">
                    <span>&darr;</span>
                    <span>&uarr;</span>
                  </Icon>
                )}
              </span>
            </div>
          </DataTableRow>
          <DataTableRow size="md">
            <div onClick={() => onSortColumn('lead_status')} style={{ cursor: 'pointer' }}>
              <span className="sub-text">
                Lead Activity Status
                {currentSortBy === 'lead_status' ? (
                  <Icon className="ms-1" name={currentSortDir === 'asc' ? 'arrow-long-up' : 'arrow-long-down'} />
                ) : (
                  <Icon className="ms-1">
                    <span>&darr;</span>
                    <span>&uarr;</span>
                  </Icon>
                )}
              </span>
            </div>
          </DataTableRow>
          <DataTableRow size="md" className="d-sm-none d-xxl-table-cell">
            <div
              onClick={() => onSortColumn('created_at')}
              style={{ cursor: 'pointer' }}
              className="d-sm-none d-xxl-table-cell"
            >
              <span className="sub-text">
                Created
                {currentSortBy === 'created_at' ? (
                  <Icon className="ms-1" name={currentSortDir === 'asc' ? 'arrow-long-up' : 'arrow-long-down'} />
                ) : (
                  <Icon className="ms-1">
                    <span>&darr;</span>
                    <span>&uarr;</span>
                  </Icon>
                )}
              </span>
            </div>
          </DataTableRow>
          <DataTableRow size="md" className="d-sm-none d-xxl-table-cell">
            <div
              onClick={() => onSortColumn('updated_at')}
              style={{ cursor: 'pointer' }}
              className="d-sm-none d-xxl-table-cell"
            >
              <span className="sub-text">
                Last modified
                {currentSortBy === 'updated_at' ? (
                  <Icon className="ms-1" name={currentSortDir === 'asc' ? 'arrow-long-up' : 'arrow-long-down'} />
                ) : (
                  <Icon className="ms-1">
                    <span>&darr;</span>
                    <span>&uarr;</span>
                  </Icon>
                )}
              </span>
            </div>
          </DataTableRow>
          <DataTableRow className="nk-tb-col-tools">
            <ul className="nk-tb-actions gx-1 my-n1"></ul>
          </DataTableRow>
        </DataTableHead>

        {
          leads &&
            leads.length > 0 &&
            leads.map((item, index) => {
              const isRowSelected = selectedItemIds.some((selItem) => String(selItem.id) === String(item.id));
              return (
                <DataTableItem key={item.id + '-leadrow'}>
                  <DataTableRow className="nk-tb-col-check">
                    <div className="custom-control custom-control-sm custom-checkbox notext">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={isRowSelected}
                        id={item.id + '-leadcheck'} // Unique ID for checkbox
                        onChange={(e) => onSelectRow(e, item.id, item.lead_status)}
                      />
                      <label className="custom-control-label" htmlFor={item.id + '-leadcheck'}></label>
                    </div>
                  </DataTableRow>
                  <DataTableRow className="d-sm-none d-xxl-table-cell">
                    <span className="d-sm-none d-xxl-table-cell">{item?.lead_source}</span>
                  </DataTableRow>
                  <DataTableRow>
                    {(item?.currentAgent?.userId?.id === authuser.id ||
                    [newRoles.MasterAdmin, newRoles.Admin, newRoles.ChannelPartnerManager].includes(authuser.role)) ? (
                      <Link to={`/user-profile/${item?.id}/user-profile-setting`} className="d-flex align-items-center">
                        <span className="ml-2">
                          {item?.first_name} {item?.last_name}
                        </span>
                        {item?.isProspect && <ProspectStar className={'text-orange'} />}
                        <NewLeadFlagComponent
                          className="d-inline-flex align-items-center justify-content-center p-2"
                          lead_created={item?.created_at}
                          lead_status={item?.lead_status}
                          lead_id={item?.id}
                          activities={item?.activities}
                        />
                      </Link>
                    ) : (
                      <>
                        <span className="ml-2">
                          {item?.first_name} {item?.last_name}
                        </span>
                        {item?.isProspect && <ProspectStar className={'text-orange'} />}
                        <NewLeadFlagComponent
                          className="d-inline-flex align-items-center justify-content-center p-2"
                          lead_created={item?.created_at}
                          lead_status={item?.lead_status}
                          lead_id={item?.id}
                          activities={item?.activities}
                        />
                      </>
                    )}
                  </DataTableRow>
                  {authuser?.role &&
                    ![newRoles.Agent, newRoles.AnonymousAgent, newRoles.TeamLeader, newRoles.ChannelPartnerAgent].includes(authuser?.role) && (
                      <DataTableRow>
                        {item.currentAgent && Object.keys(item.currentAgent).length ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <AgentColumn user={item} authUser={authuser} />
                          </div>
                        ) : (
                          <Badge color="light">Not Assigned</Badge>
                        )}
                      </DataTableRow>
                    )}
                  <DataTableRow className={'text-start'}>
                    {item?.currentAgent?.userId?.id === authuser.id ||
                    [newRoles.Admin, newRoles.MasterAdmin].includes(authuser.role) ? (
                      item?.DndStatus ? (
                        <DndFlagComponent
                          className={'d-flex flex-column mt-1'}
                          lead_status={item?.lead_status}
                          badgeClassName="align-self-start"
                          isEnquiry={item?.isEnquiry}
                          phoneNumber={item?.phone}
                        />
                      ) : (
                        <div className="">
                          <span href="#id">{item?.phone}</span>
                          <SendToPhone leadId={item?.id}>
                            <Button outline size="xs">
                              Send to Phone
                            </Button>
                          </SendToPhone>
                        </div>
                      )
                    ) : (
                      <span>{item?.phone}</span>
                    )}
                  </DataTableRow>
                  <DataTableRow>
                    <div style={{ display: 'flex' }}>
                      <span
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          paddingRight: 8,
                          height: 24,
                          alignItems: 'center'
                        }}
                      >
                        <Badge color="primary-dim" className="badge text-primary">
                          {item?.lead_status}
                        </Badge>
                      </span>
                      {['Lost', 'Disqualified', 'Invalid Number'].includes(item?.lead_status) &&
                        item?.modified_by &&
                        authuser?.role &&
                        [newRoles.Agent, newRoles.AnonymousAgent, newRoles.TeamLeader].includes(authuser?.role) && (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <Link
                              to={`/user-profile/${item?.modified_by.id}/user-profile`}
                              style={{
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <div>
                                <UserAvatar
                                  text={findUpper(item?.modified_by.first_name ?? '')}
                                  className={'sm'}
                                  image={getPublicDocumentUrl(item?.modified_by.photo)}
                                />
                              </div>
                              <div style={{ marginLeft: '8px' }}>
                                {item?.modified_by.first_name} {item?.modified_by.last_name}
                              </div>
                            </Link>
                          </div>
                        )}
                    </div>
                  </DataTableRow>
                  <DataTableRow size="md" className="d-sm-none d-xxl-inline-block">
                    <span className="d-sm-none d-xxl-inline-block">
                      {item?.created_at && `${formatDistanceToNow(new Date(item?.created_at))} ago`}
                    </span>
                  </DataTableRow>
                  <DataTableRow size="md" className="d-sm-none d-xxl-inline-block">
                    <span className="d-sm-none d-xxl-inline-block">
                      {item?.updated_at && `${formatDistanceToNow(new Date(item?.updated_at))} ago`}
                    </span>
                  </DataTableRow>
                  <DataTableRow className="nk-tb-col-tools">
                    {[newRoles.Admin, newRoles.MasterAdmin].includes(authuser.role) ||
                    item?.currentAgent?.userId?.id === authuser.id ? (
                      <ul className="nk-tb-actions gx-1">
                        <li className="nk-tb-action-hidden" onClick={() => onViewDetails(item?.id, item)}>
                          <TooltipComponent
                            tag="a"
                            containerClassName="btn btn-trigger btn-icon"
                            id={'view' + item.id}
                            icon="eye"
                            direction="top"
                            text="View Details"
                          />
                        </li>
                        <li>
                          <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="btn btn-icon dropdown-toggle btn-trigger">
                              <Icon name="more-h" />
                            </DropdownToggle>
                            <DropdownMenu end>
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Link to={`/user-profile/${item?.id}/user-profile-setting`}>
                                    <Icon name="user" />
                                    <span>User Details</span>
                                  </Link>
                                </li>
                                <li>
                                  <DropdownItem
                                    tag="a"
                                    href="#editLead"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      onEditLead(e, item.id);
                                    }}
                                  >
                                    <Icon name="edit" />
                                    <span>Edit Lead</span>
                                  </DropdownItem>
                                </li>
                                <li key={index + Math.random()}>
                                  <DropdownItem tag="a" href="#dropdown">
                                    <SendToPhone leadId={item?.id}>
                                      <Icon name="eye"></Icon>
                                      <span>Send to Phone</span>
                                    </SendToPhone>
                                  </DropdownItem>
                                </li>
                                {authuser?.roles &&
                                  [newRoles.Agent, newRoles.AnonymousAgent, newRoles.TeamLeader].includes(
                                    authuser?.role
                                  ) && (
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#returnLead"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          onReturnLead(item?.id ?? item?._id);
                                        }}
                                      >
                                        <Icon name="undo" />
                                        <span>Return Lead</span>
                                      </DropdownItem>
                                    </li>
                                  )}
                              </ul>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </li>
                      </ul>
                    ) : null}
                  </DataTableRow>
                </DataTableItem>
              ); // Closing parenthesis for return statement inside map
            }) // Closing parenthesis for map function
        }
      </DataTableBody>
    </>
  );
};

const AgentColumn = ({ user, authUser }) => {
  const isChannelPartnerManager = authUser?.role === newRoles?.ChannelPartnerManager;

  // if (isChannelPartnerManager) {
  //   return (
  //     <span
  //       style={{
  //         display: 'flex',
  //         alignItems: 'center'
  //       }}
  //     >
  //       <div>
  //         <UserAvatar
  //           text={findUpper(user?.currentAgent?.userId?.first_name ?? user?.currentAgent?.user?.first_name ?? '')}
  //           className={'sm'}
  //           image={getPublicDocumentUrl(user?.currentAgent?.userId?.photo ?? user?.currentAgent?.user?.photo)}
  //         />
  //       </div>
  //       <div style={{ marginLeft: '8px' }}>
  //         {user?.currentAgent?.userId?.first_name} {user?.currentAgent?.userId?.last_name}
  //       </div>
  //     </span>
  //   );
  // }

  return (
    <Link
      to={`/user-profile/${user?.currentAgent?.userId?.id}/user-profile`}
      style={{
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <div>
        <UserAvatar
          text={findUpper(user?.currentAgent?.userId?.first_name ?? user?.currentAgent?.user?.first_name ?? '')}
          className={'sm'}
          image={getPublicDocumentUrl(user?.currentAgent?.userId?.photo ?? user?.currentAgent?.user?.photo)}
        />
      </div>
      <div style={{ marginLeft: '8px' }}>
        {user?.currentAgent?.userId?.first_name} {user?.currentAgent?.userId?.last_name}
      </div>
    </Link>
  );
};

export default LeadsDataTable;
